import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'ds-rg-otp-verfication',
  templateUrl: './rg-otp-verfication.component.html',
  styleUrl: './rg-otp-verfication.component.scss'
})
export class RgOtpVerficationComponent {
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
  mailId = 'Johndoe@lnw.com';

  @Input() isCasinoAccVerfication : boolean; 
}
